import React from "react";

import gql from "graphql-tag";
import { Query } from "@apollo/client/react/components";
import LoadingView from "./LoadingView";
import ErrorView from "./ErrorView";

import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import { Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import NavItem from "react-bootstrap/NavItem";
import { LinkContainer } from "react-router-bootstrap";

const MAX_PROCESSES = 500;

const GET_BANK_BOOKINGS = gql`
  query clientBankBookings {
    clientBankBookings {
      bookingType
      subject
      name
      valutaTs
      isNacherstattung
      amount
      updatedAtTs
      ocrProcess
    }
  }
`;

const GET_ACCOUNT_BALANCE = gql`
  query clientAccountBalance {
    clientAccountBalance
  }
`;

function formatTimestamp(ts: number) {
  const d = new Date(ts * 1000);
  return d.toLocaleString("de-DE");
}

function timestampToDay(ts: number) {
  const d = new Date(ts * 1000);
  return d.toLocaleString("de-DE", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}

export default class BankBookingTable extends React.Component<any> {
  constructor(props: any) {
    super(props);
  }

  render() {
    return (
      <>
        <Query query={GET_ACCOUNT_BALANCE}>
          {({ loading, error, data, refetch }: any) => {
            if (loading) {
              return <LoadingView />;
            }

            if (error) {
              return <ErrorView error={error} />;
            }

            if (data.clientAccountBalance) {
              return (
                <p style={{ textAlign: "center" }}>
                  <h3>Aktueller Kontostand: </h3>
                  <h4>
                    {(data.clientAccountBalance / 100).toLocaleString("de-DE") +
                      " "}
                    EUR
                  </h4>
                </p>
              );
            } else {
              return (
                <h4 style={{ textAlign: "center" }}>
                  Kein aktueller Kontostand vorhanden
                </h4>
              );
            }
          }}
        </Query>
        <div style={{ paddingTop: "40px" }} />
        <Query query={GET_BANK_BOOKINGS} partialRefetch={true}>
          {({ loading, error, data, refetch }: any) => {
            if (loading) {
              return <LoadingView />;
            }

            if (error) {
              return <ErrorView error={error} />;
            }

            if (
              !data.clientBankBookings ||
              data.clientBankBookings.length == 0
            ) {
              return (
                <h4 style={{ textAlign: "center" }}>
                  Keine Buchungen innerhalb der letzten 6 Wochen
                </h4>
              );
            }

            return (
              <>
                <div
                  className="table-responsive"
                  style={{
                    borderStyle: "solid",
                    borderColor: "#dee2e6",
                    borderWidth: `${
                      this.props.displayTopBorder || "0px"
                    } 1px 1px 1px`,
                    marginBottom: 100,
                    marginTop: 20,
                    padding: 10,
                  }}
                >
                  <table
                    className="table table-hover middle"
                    style={{ borderTop: "1px solid #dee2e6" }}
                  >
                    <thead>
                      <tr style={{ fontSize: "1.2em" }}>
                        <th scope="col">Buchungsdatum</th>
                        <th scope="col">Buchungstyp</th>
                        <th scope="col">Buchungstext</th>
                        <th scope="col">Name</th>
                        <th scope="col">Betrag</th>
                        <th scope="col">Nacherstattung</th>
                        <th scope="col">Erfasst</th>
                        <th scope="col">Vorgang</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.clientBankBookings.map((item: any) => (
                        <tr key={item.updatesAtTs}>
                          <td>{timestampToDay(item.valutaTs)} </td>
                          <td>{item.bookingType}</td>
                          <td>{item.subject}</td>
                          <td>{item.name}</td>
                          <td
                            style={{
                              color: item.amount.startsWith("-")
                                ? "red"
                                : "green",
                            }}
                          >
                            {item.amount}&nbsp;EUR
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.isNacherstattung ? "✓" : "✗"}
                          </td>
                          <td>{formatTimestamp(item.updatedAtTs)}</td>
                          <td>
                            {item.ocrProcess && (
                              <LinkContainer to={`/vorgang/${item.ocrProcess}`}>
                                <NavItem>
                                  <Nav.Link
                                    href={`/vorgang/${item.ocrProcess}`}
                                  >
                                    {item.ocrProcess}
                                  </Nav.Link>
                                </NavItem>
                              </LinkContainer>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            );
          }}
        </Query>
      </>
    );
  }
}
